<template>
  <div>
    <!-- 产品分类列表 - 筛选 -->
    <div class="all-center-box">
      <div
        class="header-nav"
        style="display: flex;justify-content: space-between;margin-top: 1.25rem;"
      >
        <div class="classifierBox">
          <div class="box-info1"><span>产品分类</span></div>
          <div id="classifier" class="classifier" ref="classifierRef">
          <el-tree
            v-model="categoryId"
            node-key="id"
            :highlight-current="true"
            :default-expand-all="false"
            :current-node-key="categoryId"
            style="height: calc(100% - 2.875rem); font-size: 0.85rem;"
            :data="categoryOptions"
            :props="defaultProps"
            @node-click="handleNodeClick"
            :default-checked-keys="checkedkeys"
            :default-expanded-keys="[categoryId]"
          ></el-tree>
        </div>
        </div>
        
         <!-- id="containerRef"
          class="container" -->
        <div
          v-if="!showDetails"
          ref="containerRef"
          style="width: 85%"
        >
          <div class="address-box w-100 font-bold" style="font-size: 1rem;">
            <a @click="$router.push('/')">首页</a>
            <template v-if="getCategoryData[0]"
              >/<a @click="handleTabClick(0)">{{
                getCategoryData[0].name
              }}</a></template
            >
            <template v-if="getCategoryData[1]"
              >/
              <a @click="handleTabClick(1)">{{
                getCategoryData[1].name
              }}</a></template
            >
            <template v-if="getCategoryData[2]"
              >/
              <a @click="handleTabClick(2)">{{
                getCategoryData[2].name
              }}</a></template
            >
            <img @click="$router.go(-1)" class="back-img" src="../../assets/images/right-back.png" alt="">
          </div>
          <div class="product-screen w-100">
            <div class="box-info1 w-100" v-if="categoryList.length">
              <div class="between-center w-100">
                <div class="title">型材系列：</div>
                <div
                  class="info"
                  :style="{
                    height: isExpanded ? 'unset' : '2.2rem',
                    paddingRight: 'unset'
                  }"
                >
                  <div class="w-100">
                    <a
                      style="cursor: pointer"
                      v-for="(con, index) in categoryList"
                      :key="con.id"
                      @click="filterConList(con, index)"
                      :class="conIndex === index ? 'active' : ''"
                      >{{ con.name }}</a
                    >
                  </div>
                </div>
                <!-- <div
                  @click="expandedMore"
                  class="more"
                  v-if="categoryList.length > 5"
                >
                  <span>更多</span>
                </div> -->
              </div>
            </div>
            <!-- <div class="box-info1 w-100" v-if="conList.length"> -->
            <div class="box-info1 w-100" v-if="false">
              <div class="category w-100">
                <div class="title" style="padding-top: 1rem">条件筛选：</div>
                <div
                  :style="{ height: isExpand ? 'auto' : '50px' }"
                  class="list-groups"
                >
                  <div
                    v-for="(item, index) in conList"
                    class="list"
                    :key="item.id"
                  >
                    <!-- 下拉选择 -->
                    <div
                      class="categorys"
                      v-if="item.eshopGdGoodsSpecValueTbls[0].type === 2"
                    >
                      <div
                        class="title"
                        style="margin-right: 0.6rem; width: auto"
                      >
                        {{ item.name }}
                      </div>
                      <el-select
                        v-model="filterList[item.id]"
                        filterable
                        clearable
                        placeholder="请选择"
                        @change="filterChange($event, item)"
                      >
                        <el-option
                          v-for="con in item.eshopGdGoodsSpecValueTbls"
                          :key="con.value"
                          :label="con.value"
                          :value="con.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <!-- 输入步进值 -->
                    <div
                      class="categorys"
                      v-if="item.eshopGdGoodsSpecValueTbls[0].type === 1"
                    >
                      <div
                        class="title"
                        style="margin-right: 0.6rem; width: auto"
                      >
                        {{ item.name }}
                      </div>
                      <el-input
                        clearable
                        placeholder="请输入"
                        v-model="item.value"
                        @blur="handleInputChange(index, item.value)"
                      ></el-input>
                      <div style="display: flex; justify-content: center">
                        <div class="box">
                          {{
                            item.eshopGdGoodsSpecValueTbls[0].value +
                              "/" +
                              item.eshopGdGoodsSpecValueTbls[0].difference
                          }}
                        </div>
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="
                            `步进值${item.eshopGdGoodsSpecValueTbls[0].difference}`
                          "
                          placement="right"
                        >
                          <i class="el-icon-question"></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div @click="expandFilter" class="box-info2 w-100" v-if="conList.length > 4"> -->
            <div @click="expandFilter" class="box-info2 w-100" v-if="false">
              <a href="javascript:;"
                ><span>{{ !isExpand ? "更多筛选条件" : "收起筛选条件" }}</span>
                <i
                  style="color: #fff"
                  :class="!isExpand ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                ></i>
              </a>
            </div>
            <div class="box-info3 w-100 between-center">
              <div class="pull-left">产品列表</div>
              <div class="pull-right between-center">
                <div class="box1">
                  <span
                    :class="active == 0 ? 'active' : ''"
                    @click="changeBox(0)"
                    >大图</span
                  >
                  <span
                    :class="active == 1 ? 'active' : ''"
                    @click="changeBox(1)"
                    >列表</span
                  >
                </div>
                <div class="box2">
                  <span
                    >共 <i>{{ total }}</i> 件商品</span
                  ><span
                    ><i>{{ pageIndex }}</i> / {{ pCount }}</span
                  >
                </div>
              </div>
            </div>
            <div class="box-info4 w-100" v-show="active == 0">
              <div
                class="no-content"
                style="display: flex; justify-content: center"
                v-if="total <= 0"
              >
                <img src="../../../static/img/no_data5.png" />
              </div>
              <ul style="display: flex;flex-wrap: wrap;" v-else>
                <li
                  v-for="(item, index) in goodsList"
                  :key="index"
                  @click="productDetails(item)"
                >
                  <a>
                    <i
                      ><img
                        :src="
                          item.coverUrl
                            ? item.coverUrl
                            : '../../../static/img/goods_defalut.png'
                        "
                    /></i>
                    <p :title="item.name">{{ item.name }}</p>
                    <!-- <span>{{ item.modelNumber || "无" }}</span> -->
                  </a>
                </li>
              </ul>
            </div>
            <div class="box-info5 w-100" v-show="active == 1">
              <div
                class="no-content"
                style="display: flex; justify-content: center"
                v-if="total <= 0"
              >
                <img src="../../../static/img/no_data5.png" />
              </div>
              <table class="table table-bordered" v-else>
                <tr>
                  <th width="8%">图例</th>
                  <th width="41%">系列名称</th>
                  <th width="41%">产品属性</th>
                </tr>
                <tr
                  v-for="(item, index) in goodsList"
                  :key="index"
                  @click="productDetails(item)"
                >
                  <td>
                    <a
                      ><img
                        :src="
                          item.coverUrl
                            ? item.coverUrl
                            : '/static/img/goods_defalut.png'
                        "
                    /></a>
                  </td>
                  <td>
                    <a>{{ item.name }}</a>
                  </td>
                  <td>{{ item.modelNumber || "无" }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="fanye w-100">
            <div class="pull-right">
              <!-- <ul class="between-center">
							<li><a href="">&lt;</a></li>
							<li><a href="" class="active">1</a></li>
							<li><a href="">2</a></li>
							<li><a href="">3</a></li>
							<li><a href="">4</a></li>
							<li><a href="">5</a></li>
							<li><a href="">6</a></li>
							<li><a href="">&gt;</a></li>
						</ul> -->
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="pageSize"
                :total="total"
                :current-page="pageIndex"
                :page-count="pCount"
                @current-change="currentChange"
                v-if="total > 0"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <Details
          v-if="showDetails"
          :obj="detailsIndos"
          :detailsWidth="detailsWidth"
          @getCategoryList="getCategoryCallBack"
          @click="pageJump"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {
  getgoodsList,
  getCategories,
  getCategoryFilterList
} from "../../common/http.js";
import Details from "./details.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Details
  },
  filters: {
    specFormat: function(value) {
      if (value) {
        let str = "";
        if (value.specKeys.length > 0 && value.specInsts.length > 0) {
          str = value.specKeys[0].name + "：" + value.specInsts[0].name;
        }
        return str;
      }
      return "";
    }
  },
  data() {
    return {
      categoryOptions: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      filterData: [],
      goodsList: [],
      pageIndex: 1,
      pageSize: 28,
      category: "",
      total: 10,
      pCount: 0,
      active: 0,
      conIndex: "",
      conList: [], // 条件筛选
      categoryList: [], // 分类筛选
      filterList: {}, // 筛选数据
      inputValue: "",
      selectList: [], // 条件筛选
      specification: [], // 条件筛选
      categoryId: 0,
      isExpand: false,
      detailsIndos: {},
      detailsWidth: "20%",
      expandedkeys: [],
      checkedkeys: [],
      categoryCallBackList: [],
      isExpanded: false
    };
  },
  created() {
    if (this.$route.query) {
      this.categoryId = Number(
        this.$route.query.id
          ? this.$route.query.id
          : this.$route.query.productId
      );
      this.category = this.$route.query;
      this.checkedkeys = [this.categoryId];
      this.getCategoryList();
    }
    if (this.$route.query.uid) {
      this.$store.commit("setShowDetails", true);
      localStorage.setItem("goodsId", this.$route.query.uid);
      this.detailsIndos = this.$route.query.uid;
    } else {
      this.$store.commit("setShowDetails", false);
      localStorage.setItem("goodsId", '');
      this.detailsIndos = ''
      this.getGoods();
      this.getCategoryFilterLists();
    }
    // let that = this;

    console.log('getCategoryData', this.getCategoryData)
  },
  computed: {
    ...mapGetters(["getCategoryData", "showDetails"])
  },
  watch: {
    filterListss(val) {
      if (this.showDetails) {
        return;
      }
      for (const key in val) {
        this.selectList.push({
          specKeyId: key.toString(),
          value: val[key]
        });
      }

      let newArr = Array.from(
        new Set(this.selectList.map(item => item.specKeyId))
      ).map(specKeyId => {
        return this.selectList.find(item => item.specKeyId === specKeyId);
      });
      let opt = {
        specification: newArr
      };
      // 获取商品列表
      getgoodsList(opt).then(res => {
        if (res.result) {
          this.goodsList = res.data.rows;
          // this.pCount = res.data.size;
          this.pCount = res.data.pages;
          this.total = res.data.total;
        }
      });
    },
    goodsList(val) {
      if (val.length <= 7) {
        // this.$refs.classifierRef.style.height = `calc(100vh - 24.5rem)`
      }
      // if (val.length <= 14) {
      //   this.$refs.classifierRef.style.height = `calc(100vh - 12.5rem)`
      // }
      // if (val.length > 14) {
      //   this.$refs.classifierRef.style.height = `calc(100vh - 10.5rem)`
      // }
    }
  },
  methods: {
    getCategoryCallBack(e) {
      this.categoryCallBackList = e
      console.log('getCategoryCallBack', e)

      // 递归查找所有父级节点
      const findParents = (data, targetId, path = []) => {
        for (const item of data) {
          if (item.id === targetId) {
            return [...path, item];
          }
          if (item.children) {
            const result = findParents(item.children, targetId, [
              ...path,
              item
            ]);
            if (result) {
              return result;
            }
          }
        }
        return null;
      };

      const lastChildren = this.categoryCallBackList[this.categoryCallBackList.length - 1]
      if (!lastChildren) return
      // 查找匹配的节点及其所有父级
      const parents = findParents(this.categoryOptions, this.categoryCallBackList[this.categoryCallBackList.length - 1].id);
      this.$store.commit("SET_CATEGORYDATA", parents);
    },
    expandedMore() {
      // if (this.categoryList.length > 5) {
      //   this.isExpanded = true;
      // }
      this.isExpanded = !this.isExpanded;
    },
    getCategoryList() {
      getCategories({
        type: 1
      }).then(res => {
        if (res.result) {
          // this.categorys = res.data
          function filterList(list) {
            list.forEach(item => {
              if (item.children) {
                filterList(item.children);
              }

              (item.value = item.id),
                (item.label = item.name),
                (item.tree = item.children);
            });
            return list;
          }
          const options = filterList(res.data);
          this.categoryOptions = JSON.parse(JSON.stringify(options));
          // this.$nextTick(() => {
          //   this.setExpandedKeys(this.categoryOptions);
          // });
        }
      });
    },
    handleTabClick(num) {
      console.log(this.getCategoryData[num]);
      let _this = this;
      _this.conIndex = "";
      _this.categoryId = Number(this.getCategoryData[num].id);
      _this.checkedkeys = [this.getCategoryData[num].id];
      _this.getGoods();
      _this.getCategoryFilterLists();

      // 递归查找所有父级节点
      const findParents = (data, targetId, path = []) => {
        for (const item of data) {
          if (item.id === targetId) {
            return [...path, item];
          }
          if (item.children) {
            const result = findParents(item.children, targetId, [
              ...path,
              item
            ]);
            if (result) {
              return result;
            }
          }
        }
        return null;
      };

      // 查找匹配的节点及其所有父级
      const parents = findParents(
        this.categoryOptions,
        this.getCategoryData[num].id
      );
      this.$store.commit("SET_CATEGORYDATA", parents);
    },
    // 设置展开的节点
    setExpandedKeys(list) {
      this.expandedkeys.push(this.categoryId);
      let arr = list.filter(item => item.id == this.categoryId);
      arr[0].children.forEach(item => {
        if (item.children && item.children.length > 0) {
          this.expandedkeys.push(item.children[0].id);
        }
        this.expandedkeys.push(item.id);
      });
    },
    handleNodeClick(data, res) {
      this.handleFilterCategory(data, res);
      let that = this;
      that.pageIndex = 1
      that.category.obj = data.id;
      that.conList = [];
      that.categoryList = [];
      // that.showDetails = false;
      that.$store.commit("setShowDetails", false);
      that.categoryId = data.id;
      that.getGoods();
      that.getCategoryFilterLists();
    },
    handleFilterCategory(res, data) {
      this.conIndex = "";
      // 点击一级
      if (!data.data.parent) {
        this.category.parent = data.data.name;
        this.category.child = "";
        this.category.childrenName = "";
      }
      // 递归查找所有父级节点
      const findParents = (data, targetId, path = []) => {
        for (const item of data) {
          if (item.id === targetId) {
            return [...path, item];
          }
          if (item.children) {
            const result = findParents(item.children, targetId, [
              ...path,
              item
            ]);
            if (result) {
              return result;
            }
          }
        }
        return null;
      };

      // 查找匹配的节点及其所有父级
      const parents = findParents(this.categoryOptions, res.id);
      this.$store.commit("SET_CATEGORYDATA", parents);
      this.filterData = parents;
      if (parents) {
        // 二级分类
        if (parents.length === 2) {
          this.category.parent = parents[0].name;
          this.category.child = parents[1].name;
          this.category.childrenName = "";
        }
        // 三级分类
        else if (parents.length === 3) {
          this.category.parent = parents[0].name;
          this.category.child = parents[1].name;
          this.category.childrenName = parents[2].name;
        }
      }
    },
    filterChange(value, data) {
      if (value === "") {
        const index = this.selectList.indexOf(item =>
          item.specKeyId.includes(data.speckeyid)
        );
        this.selectList.splice(index, 1);
      } else {
        const newSelect = data.eshopGdGoodsSpecValueTbls.find(
          item => item.value == value
        );
        this.selectList.push({
          specKeyId: newSelect.speckeyid,
          value: value
        });
      }
      let newArr = Array.from(
        new Set(this.selectList.map(obj => obj.specKeyId))
      ).map(specKeyId => {
        return this.selectList.find(obj => obj.specKeyId === specKeyId);
      });
      let opt = {
        categoryId: this.categoryId,
        specification: newArr
      };
      // 获取商品列表
      getgoodsList(opt).then(res => {
        if (res.result) {
          this.goodsList = res.data.rows;
          // this.pCount = res.data.size;
          this.pCount = res.data.pages;
          this.total = res.data.total;
        }
      });
    },
    handleInputChange(index, val) {
      if (!val) return
      const inputValue = this.conList[index].value;
      const value = this.conList[index].eshopGdGoodsSpecValueTbls[0].value;
      const difference = this.conList[index].eshopGdGoodsSpecValueTbls[0]
        .difference;
      const speckeyid = this.conList[index].eshopGdGoodsSpecValueTbls[0]
        .speckeyid;
      const match = value.match(/\d+/g);
      const num1 = parseInt(match[0]);
      const num2 = parseInt(match[1]);
      if (inputValue === "") {
        return;
      }
      if (inputValue < num1 || inputValue > num2) {
        this.$message.error("请输入范围内的值");
        return;
      }
      if (inputValue % difference !== 0) {
        this.$message.error("错误的步进值");
        return;
      }
      this.inputValue = inputValue;
      this.selectList.unshift({
        specKeyId: speckeyid,
        value: inputValue
      });
      let newArr = Array.from(
        new Set(this.selectList.map(obj => obj.specKeyId))
      ).map(specKeyId => {
        return this.selectList.find(obj => obj.specKeyId === specKeyId);
      });
      // this.specification = newArr;
      let opt = {
        // categoryId: this.categoryId,
        specification: JSON.stringify(newArr)
      };
      // 获取商品列表
      getgoodsList(opt).then(res => {
        if (res.result) {
          this.goodsList = res.data.rows;
          // this.pCount = res.data.size;
          this.pCount = res.data.pages;
          this.total = res.data.total;
        }
      });
    },
    async getCategory(id) {
      await getCategories({
        uid: id,
        isChildren: 1
      }).then(res => {
        if (res.result) {
          this.category = res.data.children;
        }
      });
    },
    getCategoryFilterLists(id) {
      getCategoryFilterList({ categoryId: this.categoryId }).then(res => {
        if (res.result) {
          this.conList = res.data.conList;
          // this.categoryId = this.categoryList[0].id;
          this.categoryList = res.data.categoryList;
        }
      });
    },
    filterConList(con, index) {
      this.conIndex = index;
      this.categoryId = con.id;
      let opt = {
        categoryId: con.id
      };
      // 递归查找所有父级节点
      const findParents = (data, targetId, path = []) => {
        for (const item of data) {
          if (item.id === targetId) {
            return [...path, item];
          }
          if (item.children) {
            const result = findParents(item.children, targetId, [
              ...path,
              item
            ]);
            if (result) {
              return result;
            }
          }
        }
        return null;
      };

      // 查找匹配的节点及其所有父级
      const parents = findParents(this.categoryOptions, con.id);
      // 获取商品列表
      getgoodsList(opt).then(res => {
        if (res.result) {
          this.goodsList = res.data.rows;
          // this.pCount = res.data.size;
          this.pCount = res.data.pages;
          this.total = res.data.total;
        }
      });
      this.$store.commit("SET_CATEGORYDATA", parents);
    },
    getGoods() {
      let opt = {
        categoryId: this.categoryId,
        pageIndex: this.pageIndex,
        pageSize: 28
      };
      // 获取商品列表
      getgoodsList(opt).then(res => {
        if (res.result) {
          this.goodsList = res.data.rows;
          // this.pCount = res.data.size;
          this.pCount = res.data.pages;
          this.total = res.data.total;
        }
      });
    },
    changeBox(idx) {
      this.active = idx;
    },
    currentChange(e) {
      this.pageIndex = e;
      this.getGoods();
    },
    productDetails(item) {
      let that = this;
      that.$store.commit("setShowDetails", true);
      that.detailsIndos = item.uid;
      localStorage.setItem("goodsId", item.uid);

      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    },
    pageJump(data) {
      let _this = this;
      _this.conIndex = "";
      _this.$store.commit("setShowDetails", false);
      _this.categoryId = Number(data.id);
      _this.checkedkeys = [data.id];
      _this.getGoods();
      _this.getCategoryFilterLists();
      // 递归查找所有父级节点
      const findParents = (data, targetId, path = []) => {
        for (const item of data) {
          if (item.id === targetId) {
            return [...path, item];
          }
          if (item.children) {
            const result = findParents(item.children, targetId, [
              ...path,
              item
            ]);
            if (result) {
              return result;
            }
          }
        }
        return null;
      };

      // 查找匹配的节点及其所有父级
      const parents = findParents(this.categoryOptions, data.id);
      this.$store.commit("SET_CATEGORYDATA", parents);
      // _this.category.childrenName = data[type].name;
    },
    expandFilter() {
      this.isExpand = !this.isExpand;
    }
  }
};
</script>
<style scoped>
.container {
  margin-left: 20%;
}

.category {
  display: flex;
  border-top: 1px solid #eeeeee;
  padding: 1rem 0;
}

.categorys {
  display: flex;
  align-items: center;
}

.title {
  width: 10%;
  font-size: 0.875rem;
  padding-top: 0.5rem;
  color: #999;
  white-space: nowrap;
}

.category .list {
  margin-right: 4rem;
  margin-bottom: 2rem;
}

.box {
  height: 100%;
  white-space: nowrap;
  color: #999;
  font-size: 0.875rem;
  padding: 0 0.5rem;
}

.list-groups {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: 50px;
}

.tree-area {
  overflow: auto;
  scrollbar-width: none;
  width: 15%;
  /* padding: 1rem; */
  background-color: #fff;
}

.header-nav {
  display: flex;
  padding: 0 10rem;
  /* justify-content: space-between; */
  /* position: relative; */
}

.header-nav .classifierBox {
  max-height: calc(100vh - 12.5rem);
  /* overflow: auto; */
  padding: 1rem;
  background-color: #fff;
  border: 1px solid #1d66b1;
  margin: 0 1rem;
  margin-top: 1rem;
  width: 15%;
  padding-top: 3rem;
  /* position: fixed; */
  /* position: relative; */
  position: sticky;
  top: calc(38px + 7rem);
}

.header-nav .classifierBox .box-info1 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0 1.125rem;
  background: #004193;
  color: #fff;
  /* border-top-left-radius: 8px; */
  /* border-top-right-radius: 8px; */
}

.header-nav .classifierBox .box-info1 span {
  /* float: left; */
  font-size: 1.125rem;
  padding-left: 1.5rem;
  /* line-height: 2.875rem; */
  line-height: 2.3rem;
  background: url(../../assets/images/icon_6.png) no-repeat left;
  background-size: 1rem;
}

.header-nav .classifierBox .classifier {
  height: 100%;
  overflow: auto;
  width: 100%;
}

.header-nav .classifierBox .classifier::-webkit-scrollbar {
  width: 0.25rem;
}

.header-nav .classifierBox .classifier::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  border-radius: 10px;
  height: 1rem;
}

.header-nav .classifierBox .classifier::-webkit-scrollbar-thumb {
  background: #1d66b1;
  /* 滑块的颜色 */
  border-radius: 10px;
  height: 2rem;
}

.header-nav .right-area {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/pages/product/productTypeScreen.vue